export default "__VITE_ASSET__Dbb3IBo9__"